import React from 'react'
import { Query } from 'react-apollo'
import { Viewer, viewerQuery } from './shared'
import { FetchPolicy, PureQueryOptions } from 'apollo-client'
import { RouteContext } from '../route-provider'

interface ChildProps {
  readonly viewer?: Viewer
  readonly loading: boolean
  readonly error: boolean
  readonly queryInfo: PureQueryOptions
}

export interface ViewerLoaderProps {
  readonly children: (props: ChildProps) => React.ReactNode
  readonly fetchPolicy?: FetchPolicy
}

export function ViewerLoader({ children, fetchPolicy }: ViewerLoaderProps) {
  return (
    <RouteContext.Consumer>
      {({ organizationID }) => {
        return (
          organizationID && (
            <Query
              query={viewerQuery}
              variables={{
                organizationID
              }}
              errorPolicy="all"
              fetchPolicy={fetchPolicy}
            >
              {(result) => {
                const { data, error, loading } = result
                return children({
                  viewer: !!data && !!data.viewer ? data.viewer : undefined,
                  loading,
                  error: !!error,
                  queryInfo: {
                    query: viewerQuery,
                    variables: {
                      organizationID
                    }
                  }
                })
              }}
            </Query>
          )
        )
      }}
    </RouteContext.Consumer>
  )
}
